import api from '../../../services/api';

const API_URL = '/api/v1/admin/notification';
/**
 * @returns {Promise<ApiAdmin.GetAllGenericNotifications>}
 */
// eslint-disable-next-line import/prefer-default-export
export const getGenericNotificationList = () => api.get(API_URL);

/**
 * @returns {Promise<ApiAdmin.GetNotificationTagListResponse>}
 */
export const getNotificationTagList = () => api.get(`${API_URL}/tags`);

/**
 * Get all notification templates
 * @returns {Promise<{data: Array}>}
 */
export const getAllNotificationTemplates = () => api.get(`${API_URL}/templates`);

/**
 * Get a notification template by ID
 * @param {number} id
 * @returns {Promise<{data: Object}>}
 */
export const getNotificationTemplateById = (id) => api.get(`${API_URL}/templates/${id}`);

/**
 * Create a new notification template
 * @param {Object} template
 * @returns {Promise<{data: Object}>}
 */
export const createNotificationTemplate = (template) => api.post(`${API_URL}/templates`, template);

/**
 * Update an existing notification template
 * @param {number} id
 * @param {Object} template
 * @returns {Promise<{data: Object}>}
 */
export const updateNotificationTemplate = (id, template) => api.put(`${API_URL}/templates/${id}`, template);

/**
 * Duplicate a notification template
 * @param {number} sourceId
 * @param {Object} templateData - The template data including name, description, etc.
 * @returns {Promise<{data: Object}>}
 */
export const duplicateNotificationTemplate = (sourceId, templateData) => api.post(`${API_URL}/templates/${sourceId}/duplicate`, templateData);

/**
 * Delete a notification template
 * @param {number} id
 * @returns {Promise<void>}
 */
export const deleteNotificationTemplate = (id) => api.delete(`${API_URL}/templates/${id}`);
